import { API_URLS } from "@/utils/constant/api.constant";
import { C_API } from "@/utils/helper/api";

export const getUploadUrls = async (params: any) => {
  try {
    const response = await C_API.get(API_URLS.DOCS.GET_UPLOAD_URL, { params });
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
